export enum SunActionModification {
  NONE = 'none',
  DELAY = 'delay',
  ADVANCE = 'advance',
}
